import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetasResumenes: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    fechaDesde: moment(new Date()).add(-180, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(180, 'days').format('YYYY-MM-DD'),
    banco: null,
    tarjetaMarca: null
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETAS_RESUMENES' (state) {
        state.tarjetasResumenes = [];
    },
    'SET_TARJETAS_RESUMENES' (state, tarjetasResumenes) {
        state.tarjetasResumenes = tarjetasResumenes.map(tarjetaResumen => ({
            ...tarjetaResumen,
            tarjeta: `${tarjetaResumen.tarjetaMarca} ${tarjetaResumen.tarjetaNumero}`
        }))
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getTarjetasResumenes ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETAS_RESUMENES');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaCierreDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaCierreHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');

            if (state.banco) {
                if (state.banco != null) {
                    if (state.banco.id != 0) {
                        queryString += '&bancoId=' + state.banco.id;
                    }
                }
            }
                    
            if (state.tarjetaMarca) {
                if (state.tarjetaMarca != null) {
                    if (state.tarjetaMarca.id != 0) {
                        queryString += '&tarjetaMarcaId=' + state.tarjetaMarca.id;
                    }
                }
            }
            
            apiAxios.get('tarjetasresumenes/vencimientos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_TARJETAS_RESUMENES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getTarjetasNoResumenes ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETAS_RESUMENES');

            let queryString = '';

            if (state.banco) {
                if (state.banco != null) {
                    if (state.banco.id != 0) {
                        queryString = '?bancoId=' + state.banco.id;
                    }
                }
            }
                    
            if (state.tarjetaMarca) {
                if (state.tarjetaMarca != null) {
                    if (state.tarjetaMarca.id != 0) {
                        if (queryString.trim() == '') {
                            queryString += '?tarjetaMarcaId=' + state.tarjetaMarca.id;
                        } else {
                            queryString += '&tarjetaMarcaId=' + state.tarjetaMarca.id;
                        }
                    }
                }
            }

            apiAxios.get('tarjetasresumenes/no-resumen' + queryString)
                .then(res => {
                    commit('SET_TARJETAS_RESUMENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },   
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}